// Libs
import React, { useState, useEffect } from 'react'
import { EmbeddedCheckoutProvider, EmbeddedCheckout } from '@stripe/react-stripe-js'
import { loadStripe } from '@stripe/stripe-js'

// Constants
import { STRIPE_PUBLIC_TOKEN } from 'hfty'
import { PROP_CLIENT_SECRET } from 'hfty-model-orders'

export const styles = {
  outerWrapper: {
    padding: '20px',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
}

const stripePromise = loadStripe(STRIPE_PUBLIC_TOKEN)

export const Checkout = ({ operation, push }) => {
  const clientSecret = operation && operation.model ? operation.model[PROP_CLIENT_SECRET] : null

  if (!clientSecret) {
    push('/')
    return null
  }

  return (
    <div style={styles.outerWrapper}>
      <EmbeddedCheckoutProvider stripe={stripePromise} options={{ clientSecret }}>
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </div>
  )
}

export default Checkout
